import { RevenuePrices } from "./RevenuePrices";

/**Wrapper for GEO location operations on the revenue price application */
export class RevenuePricesGeo
{
	DefaultLocation: string;
	private _parent: RevenuePrices;

	/**
	 * Constructor for the GEO location operations
	 * @param parent parent object that runs the application
	 */
	constructor(parent: RevenuePrices)
	{
		this._parent = parent;
		this.DefaultLocation = 'Minnesota'
	}

	SetupDefaultLocation()
	{
		if (navigator.geolocation)
		{
			navigator.geolocation.getCurrentPosition((geolocation) =>
			{
				this.SetDefaultLocation(geolocation);
			}, (error) =>
			{
				this.ErrorCallback(error);
			});
		}
	}

	/**
	 * Execute if GEO location was retrieved
	 * @param geolocation GEO location found
	 */
	private SetDefaultLocation(geolocation)
	{
		var apiURL = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + geolocation.coords.latitude + ',' + geolocation.coords.longitude + '&key=' + window.NauUtility.nauConstants.google.apiKey;
		var geoLocationResult = '';

		window.NauUtility.loadingOps.setLoadingMessage('Location');

		$.get(apiURL, function (data)
		{
			for (var i = 0, iLen = data.results[0].address_components.length; i < iLen; i++)
			{
				// The response object returns various amounts of address definitions so we need to make sure we are targeting the state value which is defined in the types subobject
				if (data.results[0].address_components[i].types[0] === 'administrative_area_level_1')
				{
					geoLocationResult = data.results[0].address_components[i].long_name;
					break;
				}
			}
		}).then(() => {
			this._parent.ResetPageElements(geoLocationResult, null, this._parent._priceDefinitionForm.GetCurrentSelections().Filter);
		});
	}

	private ErrorCallback(error)
	{
		if (error.code === error.PERMISSION_DENIED)
		{
			window.NauUtility.loadingOps.setLoadingMessage('Default Location');
			this._parent.ResetPageElements(this.DefaultLocation, null, this._parent._priceDefinitionForm.GetCurrentSelections().Filter);
		}
	}
}